import React from "react";

function ConfiguratorHeader({currentNumber, onStepChange, stepTitles, allowClickOnStep = true, children}){

    const onStepClickHandler = stepNumber => {
        if(allowClickOnStep){
            onStepChange(stepNumber);
        }
    }

    let steps = [];
    stepTitles.forEach((title, index) => {
        let stepNumber = index + 1;
        let isActive = currentNumber === stepNumber;
        let className = "kroki-item" + (isActive ? " active" : " not-active") + (!allowClickOnStep ? " no-click" : "");

        if(index > 0) {
            steps.push(<span key={`line-${index}`} className="kroki-line"></span>);
        }

        steps.push(
            <span key={stepNumber} className={className} onClick={() => onStepClickHandler(stepNumber)}>
                {stepNumber}. {title}
            </span>
        );
    });

    return (
        <div className="config-modal-header">
            {children}
            <div className="kroki flex">
                {steps}
            </div>
        </div>
    );
}

export default ConfiguratorHeader;